import {AlarmActionsHeader} from "../utils/alarms-actions-ui.jsx";
import platePatternUtils from "../../../../utils/plate-pattern-utils.js"

const PairDiv = ({itemKey, itemValue}) =>
  <li className="py-2">
    <div className="flex justify-start">
      <span className="font-bold w-[140px]">{itemKey}</span>
      <span className={`ml-1 ${itemKey === "PLACA:" ? "font-bold" : ""}`}>{itemKey === "PLACA:" ? platePatternUtils.formatPlate(itemValue) : itemValue}</span>
    </div>
  </li>
const KeyValueCard = ({name, items = [], className, dataCortex}) => {
  const cardItems = Array.isArray(items) ? items : [];

  return(
    <div className={["w-full", className].join(" ")}>
      <AlarmActionsHeader header={name}/>
      {
        <div className="border border-[#505050] p-2 text-[#505050]! text-[14px]">
          <ul>
            {cardItems.length > 0 &&
              cardItems.map((el, index) => <PairDiv key={index} itemKey={el.label} itemValue={el.value}/>)
            }
            {dataCortex && typeof dataCortex.mjInactivationSign === "string" &&
              <li className="border-t border-[#e7e7e7]">
                <table className="mt-2">
                  <tbody>
                  {dataCortex.mjInactivationSign.split("\n").map((el, index) =>
                    <tr key={index}>
                      <td className="text-center"><p>{el}</p></td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </li>
            }
          </ul>
        </div>
      }

    </div>
  )
}

export default KeyValueCard;